import { render, staticRenderFns } from "./ConnectedLayout.vue?vue&type=template&id=aa9c6874&scoped=true&"
import script from "./ConnectedLayout.vue?vue&type=script&lang=ts&"
export * from "./ConnectedLayout.vue?vue&type=script&lang=ts&"
import style0 from "./ConnectedLayout.vue?vue&type=style&index=0&id=aa9c6874&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9c6874",
  null
  
)

export default component.exports